// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__YUtyW","buttons":"Footer_buttons__1pPjj"};